import React from 'react';
import { useFormatting } from '../../hooks/useFormatting';
import { HoverUnderlineSpan } from './HoverUnderlineSpan';

interface ClickableNumberProps {
  value: number;
  onClick: () => void;
  format?: 'currency' | 'number' | 'percentage';
  className?: string;
  showUnderline?: boolean;
}

export const ClickableNumber: React.FC<ClickableNumberProps> = ({
  value,
  onClick,
  format = 'currency',
  className = '',
  showUnderline = true,
}) => {
  const { formatCurrency } = useFormatting();

  const formatValue = () => {
    switch (format) {
      case 'currency':
        return formatCurrency(value);
      case 'percentage':
        return `${value.toFixed(1)}%`;
      case 'number':
        return value.toLocaleString();
      default:
        return value.toString();
    }
  };

  if (!showUnderline) {
    return (
      <span
        onClick={onClick}
        className={`cursor-pointer transition-colors ${className}`}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
          }
        }}
      >
        {formatValue()}
      </span>
    );
  }

  return (
    <HoverUnderlineSpan onClick={onClick} className={className}>
      {formatValue()}
    </HoverUnderlineSpan>
  );
};
